exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".autocomplete-result .project-name {\n  font-size: 1.2em !important;\n}\n.autocomplete-result .project-address {\n  color: #888;\n}\n.property-selection {\n  cursor: pointer;\n  background: blue;\n}\nlegend {\n  font-size: 1.4em;\n  font-weight: bold;\n}\nlegend small {\n  font-weight: normal;\n  color: #666;\n  text-transform: uppercase;\n  font-size: 0.7em;\n}\n.autocomplete input {\n  padding: 22px 10px !important;\n  font-size: 1.2em;\n}\np small {\n  text-transform: uppercase;\n}", ""]);

// exports
